// Growth-stage visuals for the web Crop Detail "Visual Growth Timeline".
// High-fidelity stage photos keyed by crop; a graceful generic fallback for the rest.
const STAGE_IMG = {
  tomato: [
    'https://images.unsplash.com/photo-1583263840577-b174af9ac796?crop=entropy&cs=srgb&fm=jpg&q=85&w=800',
    'https://images.unsplash.com/photo-1721520609152-0a02d79f46fe?crop=entropy&cs=srgb&fm=jpg&q=85&w=800',
    'https://images.unsplash.com/photo-1582284540020-8acbe03f4924?crop=entropy&cs=srgb&fm=jpg&q=85&w=800',
  ],
  generic: [
    'https://images.unsplash.com/photo-1457530378978-8bac673b8062?crop=entropy&cs=srgb&fm=jpg&q=85&w=800',
    'https://images.unsplash.com/photo-1595398390459-9c646b6fb86d?crop=entropy&cs=srgb&fm=jpg&q=85&w=800',
    'https://images.unsplash.com/photo-1624668430039-0175a0fbf006?crop=entropy&cs=srgb&fm=jpg&q=85&w=800',
  ],
};

// Crops whose middle stage is a flowering/fruit-set moment (vs pure leaf bulk).
const FLOWERING = /tomato|pepper|capsicum|chilli|cucumber|zucchini|courgette|pumpkin|squash|melon|bean|pea|eggplant|aubergine|strawberr/i;

export function growthStages(cropName, daysToHarvest) {
  const key = (cropName || '').toLowerCase();
  const matchKey = Object.keys(STAGE_IMG).find((k) => k !== 'generic' && key.includes(k));
  const imgs = STAGE_IMG[matchKey] || STAGE_IMG.generic;
  const days = daysToHarvest || 84;
  const harvestWeek = Math.max(6, Math.round(days / 7));
  const flowers = FLOWERING.test(key);
  return [
    {
      week: 2,
      title: 'Seedling',
      img: imgs[0],
      note: 'First true leaves unfurl. Keep it warm and bright, water gently and don’t let it dry out.',
    },
    {
      week: Math.min(6, harvestWeek - 2),
      title: flowers ? 'Flowering' : 'Establishing',
      img: imgs[1],
      note: flowers
        ? 'Blooms set the fruit — steady watering now decides your yield. Feed fortnightly and support the stems.'
        : 'Roots deepen and leaves bulk up fast. Feed fortnightly, thin crowded seedlings and mulch to hold moisture.',
    },
    {
      week: harvestWeek,
      title: 'Harvest',
      img: imgs[2],
      note: 'Fully mature and at peak flavour. Pick regularly to keep the plant producing and prevent waste.',
    },
  ];
}

// Fallback strategic reasons when the companion knowledge base has no `why`.
export const COMPANION_REASONS = {
  marigold: 'Repels root-knot nematodes and lures aphids away from your crop.',
  basil: 'Improves flavour and masks the scent that draws whitefly & thrips.',
  borage: 'Brings in bees for pollination and deters tomato hornworm.',
  nasturtium: 'A living trap crop — aphids swarm it instead of your veg.',
  carrot: 'Loosens the soil below while your crop shades it above.',
  lettuce: 'Shallow roots and quick growth make good use of the gaps.',
  onion: 'Its scent confuses carrot fly and many leaf-eating pests.',
  garlic: 'A natural fungicide that keeps aphids and mites at bay.',
  bean: 'Fixes nitrogen in the soil to feed hungry neighbours.',
  fennel: 'Releases growth-inhibiting compounds — keep it well away.',
  brassica: 'Competes hard for the same nutrients and stunts both crops.',
  potato: 'Shares blight and fungal diseases — keep them separated.',
};

export function reasonFor(name, isFoe) {
  const k = (name || '').toLowerCase();
  const hit = Object.keys(COMPANION_REASONS).find((x) => k.includes(x));
  if (hit) return COMPANION_REASONS[hit];
  return isFoe
    ? 'Competes for the same nutrients or shares pests — plant them apart.'
    : 'A proven good neighbour that supports healthier, higher-yield growth.';
}
